import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #FEF368;

  .WarningHeader {
    color: #c1320c;
    margin: 15px 0px;
    font-style: normal;
  }
  .WarningMessage {
    width: 900px;
    max-width: 90vw;
    text-align: center;
    font-size: 0.9rem;
    /* padding-left: 15px;
    padding-right: 15px; */
  }
  .WarningButton {
    background-color: #c1320c;
    border: 2px solid #c1320c;
    border-radius: 10px;
    color: white;
    padding: 10px 20px;
    font-size: 20px;
  }
`;
